module.exports = __webpack_public_path__ + "img/crazy_extravagant.bcf09b52.jpg";